import { render } from "./orderwist.vue?vue&type=template&id=5639c1af&scoped=true"
import script from "./orderwist.vue?vue&type=script&lang=js"
export * from "./orderwist.vue?vue&type=script&lang=js"

import "./orderwist.vue?vue&type=style&index=0&id=5639c1af&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5639c1af"]])

export default __exports__